import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import { showErrorToast } from "../../utils/toastUtils";
import Loader from "../../Loader";
import { LiaTachometerAltSolid } from "react-icons/lia";
import { FaMobileAlt } from "react-icons/fa";
import { FaEye,FaEyeSlash } from "react-icons/fa6";
import {
  FaSearch,
  FaCalendarAlt,
  FaPhone,
  FaIdCard,
  FaUser,
  FaArrowLeft,
  FaArrowRight,
  FaServer,
} from "react-icons/fa";
import { EquifaxScoreV2Service } from "../../Services/CreditReport/reportService";
import TransUnionReportModal from "../EquifaxMenu/TransUnionScore/TransUnionReport";
import TransUnionReportModal2 from "../EquifaxMenu/TransUnionScore2/TransUnionReport";
import TransUnionReportModal3 from "../EquifaxMenu/TransUnionScore3/TransUnionReport";
import EquifaxScoreReportModal from "../EquifaxMenu/EquifaxCrScorev2/Equifaxscorev2Report";
import ExperianScoreReportModal from "../EquifaxMenu/Experian2/ExperianScoreReport";
import ExperianScoreReportModals from "../EquifaxMenu/Experian/ExperianScoreReport";
import ExperianScoreReportModall from "../EquifaxMenu/Experian3/ExperianScoreReport3";
import CrifScoreReportModal from "../EquifaxMenu/CrifCreditScore/CrifScoreReport";
import { MobileDataModal } from "./MobileDataModal";
import { MobileDataModals } from "./MobileDataModals";
import CrifScoreReportModal2 from "../EquifaxMenu/CrifCreditScore2/CrifScoreReport2";
import EquifaxReport from "../EquifaxMenu/EquifaxCreditReport/EquifaxReport";
import { Info } from "lucide-react";
import CrifScoreReportModal4 from "../EquifaxMenu/CrifCreditScore4/CrifScoreReport4";
import TransunionHybridModal from "../EquifaxMenu/TransunionHybrid/ReportModal";
import { formatCreditReport } from "../../utils/formatTransunionReport";

const CreditScoreReport = () => {
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    id_number: "",
    mobile: "",
    name: "",
    select_service: "",
  });
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [selectedReport, setSelectedReport] = useState(null);
  const [modalOpen, setModalOpen] = useState({
    equifax: false,
    experians: false,
    criff: false,
    crif: false,
    experiann: false,
    experian: false,
    transunion: false,
    transunionn: false,
    transunionnn: false,
    transunionHybrid: false,
    mobile: false,
    mobilee: false,
    crifv3: false,
    crifv4: false,
  });
  const [jsonModalOpen, setJsonModalOpen] = useState(false);
  const [jsonReponseData, setJsonReponseData] = useState(null);

  const handleChange = (e) => {
    // Show loader when service selection changes
    if (e.target.name === "select_service") {
      setShowLoader(false);
    }
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleViewReport = (report) => {
    setSelectedReport(null); // Reset before parsing
    setShowLoader(true); // Show loader while selecting service

    // Use service_end_point from backend - it's more reliable
    const endpoint = report?.service_end_point || "";
    const serviceName = (report?.service_name || filters.select_service || "")
      .toLowerCase()
      .trim();

    try {
      const parsedData = JSON.parse(report?.response_data || "{}");
      setJsonReponseData(parsedData);
      setSelectedReport(parsedData);

      // Check endpoint first (most reliable), then service name
      // Order matters: Check specific versions (srv2, srv3) BEFORE generic checks

      // CRIF Services
      if (
        endpoint.includes("/srv2/credit-report/crif") ||
        (serviceName.includes("crif") && serviceName.includes("v2"))
      ) {
        setModalOpen((prev) => ({ ...prev, criff: true }));
      } else if (endpoint.includes("/credit-report/crif")) {
        setModalOpen((prev) => ({ ...prev, crif: true }));
      } else if (endpoint.includes("/crif/Credit-ScoreV4")) {
        setModalOpen((prev) => ({ ...prev, crifv4: true }));
      }
      // Experian Services
      else if (
        endpoint.includes("/srv3/credit-report/experian") ||
        (serviceName.includes("experian") && serviceName.includes("v3"))
      ) {
        setModalOpen((prev) => ({ ...prev, experiann: true }));
      } else if (
        endpoint.includes("/srv2/credit-report/experian") ||
        (serviceName.includes("experian") && serviceName.includes("v2"))
      ) {
        setModalOpen((prev) => ({ ...prev, experian: true }));
      } else if (
        endpoint.includes("/credit-report/experian") ||
        serviceName.includes("experian")
      ) {
        setModalOpen((prev) => ({ ...prev, experians: true }));
      }

      // TransUnion Services
      else if (
        endpoint.includes("/srv3/credit-report/transunion") ||
        (serviceName.includes("transunion") && serviceName.includes("v3"))
      ) {
        setModalOpen((prev) => ({ ...prev, transunionnn: true }));
      } else if (
        endpoint.includes("/srv2/credit-report/transunion") ||
        (serviceName.includes("transunion") && serviceName.includes("v2"))
      ) {
        setModalOpen((prev) => ({ ...prev, transunionn: true }));
      } else if (endpoint.includes("transunion-Score-Hybrid")) {
        setModalOpen((prev) => ({ ...prev, transunionHybrid: true }));
      } else if (
        endpoint.includes("/credit-report/transunion") ||
        serviceName.includes("transunion")
      ) {
        setModalOpen((prev) => ({ ...prev, transunion: true }));
      }

      // Equifax
      else if (
        endpoint.includes("equifax") ||
        serviceName.includes("equifax")
      ) {
        setModalOpen((prev) => ({ ...prev, equifax: true }));
      }

      // Mobile
      else if (
        endpoint.includes("mobile") ||
        serviceName.includes("mobile") ||
        serviceName === "credit score check"
      ) {
        setModalOpen((prev) => ({ ...prev, mobile: true }));
      } else if (
        endpoint.includes("credit-report/v2/experian-mobile-v2") ||
        (serviceName.includes("mobile") && serviceName.includes("v2"))
      ) {
        setModalOpen((prev) => ({ ...prev, mobilee: true }));
      } else {
        showErrorToast(`No modal found for service: ${serviceName}`);
      }
    } catch (e) {
      console.error("Error parsing response_data:", e);
      showErrorToast("Failed to parse report data");
    }
  };

  // useEffect to handle selectedReport after it's set
  useEffect(() => {
    if (selectedReport) {
    }
  }, [selectedReport]);

  // useEffect to hide loader when any modal opens
  useEffect(() => {
    const isAnyModalOpen = Object.values(modalOpen).some(Boolean);
    if (isAnyModalOpen) {
      setShowLoader(false);
    }
  }, [modalOpen]);

  const handleSearch = (page = 1) => {
    try {
      // if (filters.select_service === "") {
      //   showErrorToast("Please select service");
      //   return;
      // }
      // Only show loader if a service is selected
      if (filters.select_service !== "") {
        setShowLoader(true);
      }

      const params = {
        from_date: filters.from_date,
        to_date: filters.to_date,
        id_number: filters.id_number,
        mobile: filters.mobile,
        name: filters.name,
        select_service: filters.select_service,
      };
      // console.log("payload",params);

      EquifaxScoreV2Service(params, page)
        .then((response) => {
          setReports(Array.isArray(response.data) ? response.data : []);
          const pagination = response.pagination;
          if (pagination) {
            setTotalPages(pagination?.last_page || 1);
            setTotalData(pagination?.total || 0);
            setCurrentPage(pagination?.current_page || 1);
          }
          // Only hide loader when reports has data and service was selected
          if (
            filters.select_service !== "" &&
            response.data &&
            Array.isArray(response.data)
          ) {
            setShowLoader(false);
          }
        })
        .catch((error) => {
          setReports([]);
          showErrorToast(
            error?.data?.status?.message ||
              error?.message ||
              "Failed to fetch Equifax Score V2 Data",
          );
          if (filters.select_service !== "") {
            setShowLoader(false); // Hide loader on error only if service was selected
          }
        });
    } catch (error) {
      setReports([]);
      showErrorToast(
        error?.data?.status?.message ||
          error?.message ||
          "Failed to fetch Equifax Score V2 Data",
      );
      if (filters.select_service !== "") {
        setShowLoader(false); // Hide loader on error only if service was selected
      }
    }
  };

  const goToPage = (page) => {
    setCurrentPage(page);
    handleSearch(page);
  };

  // handleSearch call by default
  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    console.log("selecetd Service", filters?.select_service);
  }, [filters?.select_service]);

  return (
    <>
      <Seo />
      {showLoader && <Loader />}
      <Header heading="Report" />
      <div className=" w-full flex items-center gap-2 justify-center">
        <div className="bg-green-50  my-3 w-fit border border-green-600 text-green-600 rounded-lg px-3 py-6">
          <div className="flex items-center">
            <p className="flex items-center gap-2 capitalize">
              <strong className="flex items-center gap-2 ">
                <Info /> Update Alert:
              </strong>{" "}
              Here, you can view the history of Bureau reports obtained through
              the IDSPay API portal only.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto py-1">
        {/* Filter Form */}
        <div className="bg-white shadow-md rounded-lg p-1 grid grid-cols-1 md:grid-cols-6 gap-1 mb-2">
          <div className="flex items-center gap-1">
            <FaServer className="w-5 h-5 text-gray-500" />
            <select
              name="select_service"
              value={filters.select_service}
              onChange={handleChange}
              className="border border-gray-300 rounded p-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="" disabled selected>
                Select Service
              </option>

              <option value="equifax">Equifax V2</option>

              <option value="crif">CRIF Credit Score</option>

              <option value="crif-v2">CRIF Credit Score V2</option>
              {/* <option value="crif-v3">CRIF Credit Score V3</option> */}
              <option value="crif-v4">CRIF Credit Score V4</option>

              <option value="experian">Experian Credit Report</option>

              <option value="experian-v2">Experian (V2) Report</option>

              <option value="experian-v3">Experian (V3) Report</option>

              <option value="experian-mobile">Check Score Only</option>

              {/* <option value="experian-mobile-v2">
    Mobile Credit Score V2
  </option> */}

              <option value="transunion">TransUnion</option>

              <option value="transunion-v2">TransUnion Report (V2)</option>
              <option value="transunion-v3">TransUnion Report (V3)</option>
              <option value="transunion-v5">TransUnion Report Hybrid</option>
            </select>
          </div>

          <div className="flex items-center gap-1">
            <FaCalendarAlt className="w-5 h-5 text-gray-500" />
            <input
              type="date"
              name="from_date"
              value={filters.from_date}
              onChange={handleChange}
              className="border border-gray-300 rounded p-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="From Date"
            />
          </div>

          <div className="flex items-center gap-1">
            <FaCalendarAlt className="w-5 h-5 text-gray-500" />
            <input
              type="date"
              name="to_date"
              value={filters.to_date}
              onChange={handleChange}
              className="border border-gray-300 rounded p-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="To Date"
            />
          </div>

          <div className="flex items-center gap-1">
            <FaIdCard className="w-5 h-5 text-gray-500" />
            <input
              type="text"
              name="id_number"
              value={filters.id_number}
              onChange={handleChange}
              className="border border-gray-300 rounded p-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="ID Number (eg: Aadhar Number, Pan Number)"
            />
          </div>

          <div className="flex items-center gap-1">
            <FaPhone className="w-5 h-5 text-gray-500" />
            <input
              type="text"
              name="mobile"
              value={filters.mobile}
              onChange={handleChange}
              className="border border-gray-300 rounded p-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Mobile Number"
            />
          </div>

          <div className="flex items-center gap-2">
            <FaUser className="w-5 h-5 text-gray-500" />
            <input
              type="text"
              name="name"
              value={filters.name}
              onChange={handleChange}
              className="border border-gray-300 rounded p-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Name"
            />
          </div>
        </div>
        <div className="flex justify-center mt-3">
          <button
            type="button"
            onClick={handleSearch}
            disabled={isLoading}
            className={`flex items-center justify-center bg-blue-600 text-white font-semibold px-2 py-1 rounded hover:bg-blue-700 transition ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <FaSearch className="w-4 h-4 mr-2" />
            Search
          </button>
        </div>

        {/* Reports Section */}
        <div className="">
          {reports?.length === 0 ? (
            <p className="text-center text-gray-500 col-span-full">
              No reports found.
            </p>
          ) : (
            <div className="mt-2">
              {/* Info */}
              <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 space-y-2 md:space-y-0">
                <div className="text-sm text-gray-600">
                  Showing {reports.length} of {totalData} report(s)
                </div>
                <div className="text-sm text-gray-600">
                  Page {currentPage} of {totalPages}
                </div>
              </div>

              {/* Table */}
              <div className="overflow-x-auto rounded shadow bg-white">
                {/* Table for desktop/tablet */}
                <table className="hidden lg:table min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-blue-600 text-white border">
                    <tr>
                      <th className="px-1 py-0 border">SN</th>
                      <th className="px-1 py-0 border">Service</th>
                      <th className="px-1 py-0 border">Name</th>
                      <th className="px-1 py-0 border">ID Type</th>
                      <th className="px-1 py-0 border hidden sm:table-cell">
                        ID Number
                      </th>
                      <th className="px-1 py-0 border hidden sm:table-cell">
                        Mobile
                      </th>
                      <th className="px-1 py-0 border">Credit Score</th>
                      <th className="px-1 py-0 border hidden md:table-cell">
                        Date
                      </th>
                      {/* <th className="px-1 py-0 border hidden md:table-cell">
                        Message
                      </th> */}
                      {/* <th className="px-1 py-0 hidden border lg:table-cell">
                        Code
                      </th> */}
                      <th className="px-1 py-0 hidden border lg:table-cell">
                        View
                      </th>
                      {/* <th className="px-2 py-1 hidden border lg:table-cell">Json View</th> */}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {reports?.map((item, index) => {
                      const responseData = JSON.parse(item.response_data);
                      const requestData = JSON.parse(item.request_data);

                      // format data for transunion hybrid
                        const tv5 = (filters?.select_service?.includes('transunion-v5') && !responseData.error && responseData?.status === "success") ? formatCreditReport(responseData) : null;
                      const userName = requestData?.forename
                        ? requestData?.forename + " " + requestData?.surname
                        : null;

                      const scoreFromNewResponse =
                        responseData?.result?.result_json?.parsed_data?.["B2C-REPORT"]?.[
              "REPORT-DATA"
            ]?.["STANDARD-DATA"]?.SCORE?.[0]?.VALUE;
                    
            
                      const anotherScore =
                        responseData?.result?.result_json?.credit_report?.scores
                          ?.score_value;

                      const message =
                        responseData?.message ||
                        requestData?.data?.credit_report_message?.message ||
                        "";

                      const isSuccess =
                        message.toLowerCase().includes("success") ||
                        message.toLowerCase().includes("sucess");

                      return (
                        <tr
                          key={index}
                          className="hover:bg-gray-50 text-gray-700"
                        >
                          <td className="p-1 border font-bold">{index + 1}</td>
                          <td className="p-1 border">
                            {item?.service_name || "N/A"}
                          </td>
                          <td className="p-1 border font-semibold">
                            {tv5?.personal?.name ||
                              userName ||
                              requestData?.name ||
                              responseData?.result?.name ||
                              requestData?.first_name +
                                (requestData?.last_name
                                  ? " " + requestData?.last_name
                                  : "") ||
                              "N/A"}
                          </td>
                          <td className="p-1 border">
                            {requestData?.id_type || "Pan"}
                          </td>
                          <td className="p-1 border hidden sm:table-cell">
                            {requestData?.id_number ||
                              tv5?.personal?.pan ||
                              requestData?.pan ||
                              responseData?.result?.pan ||
                              "N/A"}
                          </td>
                          <td className="p-1 border hidden sm:table-cell">
                            <div className="flex items-center space-x-1 bg-blue-50 rounded-full p-1">
                              <FaMobileAlt className="text-blue-700" />
                              <span>
                                {requestData?.mobile ||
                                  tv5?.personal?.phone ||
                                  requestData?.mobile_no ||
                                  requestData?.mobile_number ||
                                  "N/A"}
                              </span>
                            </div>
                          </td>
                          <td className="p-1 border font-semibold">
                            <div className="flex items-center space-x-1 bg-blue-50 rounded-full p-1 text-blue-700">
                              <LiaTachometerAltSolid size={20} />
                              <span>
                                {(() => {
                                  try {
                                    // Parse response_data again if needed for nested paths
                                    const parsedResponse =
                                      typeof responseData === "string"
                                        ? JSON.parse(responseData)
                                        : responseData;

                                    // All your score paths (same order as modal)
                                    return (
                                      parsedResponse?.data?.credit_score ||
                                      scoreFromNewResponse ||
                                      anotherScore ||
                                      parsedResponse?.result?.score ||
                                      parsedResponse?.result?.result_json
                                        ?.INProfileResponse?.SCORE
                                        ?.BureauScore ||
                                      (() => {
                                        const reportData =
                                          parsedResponse?.data?.report_data;
                                        if (typeof reportData === "string") {
                                          const parsedReport =
                                            JSON.parse(reportData);
                                          return parsedReport?.SCORES?.SCORE?.[
                                            "SCORE-VALUE"
                                          ];
                                        }
                                        return reportData?.SCORES?.SCORE?.[
                                          "SCORE-VALUE"
                                        ];
                                      })() ||
                                      parsedResponse?.data?.report_data
                                        ?.crifData?.SCORES?.SCORE?.[
                                        "SCORE-VALUE"
                                      ] ||
                                      scoreFromNewResponse ||
                                      anotherScore ||
                                      parsedResponse?.data?.cibilData
                                        ?.GetCustomerAssetsResponse
                                        ?.GetCustomerAssetsSuccess?.Asset
                                        ?.TrueLinkCreditReport?.Borrower
                                        ?.CreditScore?.riskScore ||
                                      tv5?.score?.value ||
                                      parsedResponse?.data?.score_detail?.[0]
                                        ?.value ||
                                      "N/A"
                                    );
                                  } catch (error) {
                                    console.error(
                                      "Score parsing error:",
                                      error,
                                    );
                                    return "N/A";
                                  }
                                })()}
                              </span>
                            </div>
                          </td>
                          <td className="p-1 border hidden md:table-cell">
                            {item?.created_at || "N/A"}
                          </td>
                          {/* <td className="p-1 border hidden md:table-cell">
                            <td className="p-1 border hidden md:table-cell">
                              <span
                                className={`p-1 rounded-full text-sm font-medium ${
                                  isSuccess
                                    ? "bg-green-500 text-white"
                                    : "bg-red-100 text-red-600 text-xs"
                                }`}
                              >
                                {message || "N/A"}
                              </span>
                            </td>
                          </td> */}

                          {/* <td className="p-1 border hidden lg:table-cell">
                            <span
                              className={
                                (
                                  responseData?.message_code ||
                                  requestData?.data?.credit_report_message
                                    ?.message_code
                                )
                                  ?.toLowerCase()
                                  .includes("success" || "sucess")
                                  ? "text-green-800 font-medium"
                                  : "text-red-700 shadow-md"
                              }
                            >
                              {responseData?.message_code ||
                                requestData?.data?.credit_report_message
                                  ?.message_code ||
                                "N/A"}
                            </span>
                          </td> */}
                          <td className="p-1 border hidden lg:table-cell text-center">
                            {/* <FaEye
                            disabled={filters?.select_service?.includes("transunion-v5") && !tv5?.score?.value}
                              className="text-blue-600 disabled:opacity-50 hover:text-blue-800 cursor-pointer ml-1"
                              size={28}
                              onClick={() => handleViewReport(item)}
                            /> */}
                            <button
                              disabled={
                                filters?.select_service?.includes(
                                  "transunion-v5",
                                ) && !tv5?.score?.value
                              }
                              onClick={() => handleViewReport(item)}
                            >
                              {" "}
                              {filters?.select_service?.includes(
                                "transunion-v5",
                              ) && !tv5?.score?.value ? (
                                <FaEyeSlash
                                  className="text-gray-600  hover:text-blue-800 cursor-pointer ml-1"
                                  size={28}
                                />
                              ) : (
                                <FaEye
                                  className="text-blue-600 disabled:opacity-50 hover:text-blue-800 cursor-pointer ml-1"
                                  size={28}
                                />
                              )}
                            </button>
                          </td>
                          {/* <td className="p-1 border hidden lg:table-cell text-center">
                              <FaEye className="text-blue-600 hover:text-blue-800 cursor-pointer ml-2" 
                               size={28}
                                onClick={() => {
                                  setJsonModalOpen(true);
                                  setJsonReponseData(responseData);
                                }} />
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {/* Card layout for mobile */}
                <div className="block md:hidden p-1 space-y-2">
                  {reports?.map((item, index) => {
                    const responseData = JSON.parse(item.response_data);
                    const requestData = JSON.parse(item.request_data);
                         const scoreFromNewResponse =
                        responseData?.result?.result_json?.parsed_data?.["B2C-REPORT"]?.[
              "REPORT-DATA"
            ]?.["STANDARD-DATA"]?.SCORE?.[0]?.VALUE;
                    

                        const tv5 = (filters?.select_service?.includes('transunion-v5') && !responseData.error && responseData?.status === "success") ? formatCreditReport(responseData) : null;
                      const userName = requestData?.forename
                        ? requestData?.forename + " " + requestData?.surname
                        : null;

                    return (
                      <div
                        key={index}
                        className="border rounded-lg shadow p-2 bg-white"
                      >
                        <div className="font-bold text-blue-600">
                          #{index + 1} - {item?.service_name || "N/A"}
                        </div>
                        <div>
                          <span className="font-semibold">Name: </span>
                          {requestData?.name ||userName ||
                            responseData?.result?.name ||
                            requestData?.first_name +
                              (requestData?.last_name
                                ? " " + requestData?.last_name
                                : "") ||
                            "N/A"}
                        </div>
                        <div>
                          <span className="font-semibold">ID Type: </span>
                          {requestData?.id_type || "Pan"}
                        </div>
                        <div>
                          <span className="font-semibold">ID Number: </span>
                          {requestData?.id_number || tv5?.personal?.pan ||
                            requestData?.pan ||
                            responseData?.result?.pan ||
                            "N/A"}
                        </div>
                        <div className="flex items-center space-x-1">
                          <FaMobileAlt className="text-blue-700" />
                          <span className="font-semibold">Mobile: </span>
                          <span>
                            {requestData?.mobile || tv5?.personal?.phone ||
                              requestData?.mobile_no ||
                              requestData?.mobile_number ||
                              "N/A"}
                          </span>
                        </div>
                        <div className="flex items-center space-x-1 text-blue-700">
                          <LiaTachometerAltSolid size={20} />
                          <span className="font-semibold">Credit Score: </span>
                          <span>
                            {responseData?.data?.credit_score || tv5?.score?.value ||
                              scoreFromNewResponse ||
                              responseData?.result?.score ||
                              responseData?.result?.result_json
                                ?.INProfileResponse?.SCORE?.BureauScore ||
                              responseData?.data?.report_data?.SCORES?.SCORE?.[
                                "SCORE-VALUE"
                              ] ||
                              "N/A"}
                          </span>
                        </div>
                        <div>
                          <span className="font-semibold">Date: </span>
                          {item?.created_at || "N/A"}
                        </div>
                        {/* <div>
                          <span className="font-semibold">Message: </span>
                          <span
                            className={`px-2 py-0.5 rounded-full text-sm font-medium ${
                              (responseData?.message ||
                                requestData?.data?.credit_report_message
                                  ?.message) === "Success"
                                ? "bg-green-500 text-white"
                                : "bg-red-100 text-red-600"
                            }`}
                          >
                            {responseData?.message ||
                              requestData?.data?.credit_report_message
                                ?.message ||
                              "N/A"}
                          </span>
                        </div> */}
                        <div>
                          <span className="font-semibold">Code: </span>
                          {responseData?.message_code ||
                            requestData?.data?.credit_report_message
                              ?.message_code ||
                            "N/A"}
                        </div>
                        <div className="mt-1">
                          <button
                            onClick={() => handleViewReport(item)}
                            className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white font-medium px-2 py-1 rounded-md transition duration-200 ease-in-out"
                          >
                            <span>View</span>
                            <FaEye className="text-white" />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Tablet layout (md to < lg) */}
                <div className="hidden md:block lg:hidden space-y-3">
                  {reports?.map((item, index) => {
                    const responseData = JSON.parse(item.response_data);
                    const requestData = JSON.parse(item.request_data);
                        const scoreFromNewResponse =
                        responseData?.result?.result_json?.parsed_data?.["B2C-REPORT"]?.[
              "REPORT-DATA"
            ]?.["STANDARD-DATA"]?.SCORE?.[0]?.VALUE;
                    

                        const tv5 = (filters?.select_service?.includes('transunion-v5') && !responseData.error && responseData?.status === "success") ? formatCreditReport(responseData) : null;
                      const userName = requestData?.forename
                        ? requestData?.forename + " " + requestData?.surname
                        : null;

                    return (
                      <div
                        key={index}
                        className="flex flex-col md:flex-row md:items-center md:justify-between border rounded-lg shadow p-4 bg-gray-50"
                      >
                        {/* Left side */}
                        <div>
                          <div className="font-bold text-blue-600 text-lg">
                            #{index + 1} - {item?.service_name || "N/A"}
                          </div>
                          <div className="text-sm text-gray-600">
                            {item?.created_at || "N/A"}
                          </div>
                        </div>

                        {/* Middle info */}
                        <div className="flex flex-wrap gap-4 text-sm mt-2 md:mt-0">
                          <div>
                            <span className="font-semibold">Name: </span>
                            {requestData?.name || userName ||
                              responseData?.result?.name ||
                              requestData?.first_name +
                                (requestData?.last_name
                                  ? " " + requestData?.last_name
                                  : "") ||
                              "N/A"}
                          </div>

                          <div>
                            <span className="font-semibold">ID Type: </span>
                            {requestData?.id_type || "Pan"}
                          </div>

                          <div>
                            <span className="font-semibold">ID Number: </span>
                            {requestData?.id_number || tv5?.personal?.pan ||
                              requestData?.pan ||
                              responseData?.result?.pan ||
                              "N/A"}
                          </div>

                          <div className="flex items-center space-x-1">
                            <FaMobileAlt className="text-blue-700" />
                            <span className="font-semibold">Mobile: </span>
                            <span>
                              {requestData?.mobile || tv5?.personal?.phone ||
                                requestData?.mobile_no ||
                                requestData?.mobile_number ||
                                "N/A"}
                            </span>
                          </div>

                          <div className="flex items-center space-x-1 text-blue-700">
                            <LiaTachometerAltSolid size={18} />
                            <span className="font-semibold">
                              Credit Score:{" "}
                            </span>
                            <span>
                              {responseData?.data?.credit_score || tv5?.score?.value ||
                                scoreFromNewResponse ||
                                responseData?.result?.score ||
                                responseData?.result?.result_json
                                  ?.INProfileResponse?.SCORE?.BureauScore ||
                                responseData?.data?.report_data?.SCORES
                                  ?.SCORE?.["SCORE-VALUE"] ||
                                "N/A"}
                            </span>
                          </div>

                          {/* <div>
                            <span className="font-semibold">Message: </span>

                            <span
                              className={`px-2 py-0.5 rounded-full text-sm font-medium ${(() => {
                                const msg =
                                  responseData?.message ||
                                  responseData?.data?.credit_report_message
                                    ?.message ||
                                  "";

                                // 🔧 Clean the message
                                const cleanMsg = msg
                                  .toString()
                                  .replace(/["\\]/g, "") // remove " and \
                                  .trim()
                                  .toLowerCase();

                                const isSuccess =
                                  cleanMsg.includes("success") ||
                                  cleanMsg.includes("sucess");

                                return isSuccess
                                  ? "bg-green-500 text-white"
                                  : "bg-red-100 text-red-600";
                              })()}`}
                            >
                              {responseData?.message ||
                                responseData?.data?.credit_report_message
                                  ?.message ||
                                "N/A"}
                            </span>
                          </div> */}

                          <div>
                            <span className="font-semibold">Code: </span>
                            {responseData?.message_code ||
                              requestData?.data?.credit_report_message
                                ?.message_code ||
                              "N/A"}
                          </div>
                        </div>

                        {/* Right side actions */}
                        <div className="mt-2 md:mt-0">
                          <button
                            onClick={() => handleViewReport(item)}
                            className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white font-medium px-3 py-1 rounded-md transition duration-200 ease-in-out"
                          >
                            <span>View</span>
                            <FaEye className="text-white" />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Stylish Pagination */}
              <div className="flex justify-center mt-6 flex-wrap gap-2">
                {/* Prev */}
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="flex items-center px-3 py-2 text-sm font-medium bg-white border rounded-full shadow-sm hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <FaArrowLeft className="w-4 h-4 mr-1" />
                  Prev
                </button>

                {/* Page Numbers */}
                {Array.from({ length: totalPages > 5 ? 4 : 1 }, (_, i) => {
                  const pageNum = i + 1;
                  const isActive = currentPage === pageNum;

                  return (
                    <button
                      key={i}
                      onClick={() => goToPage(pageNum)}
                      className={`px-4 py-2 rounded-full border text-sm font-medium transition-all duration-150 ${
                        isActive
                          ? "bg-blue-600 text-white shadow-md"
                          : "bg-white text-gray-700 hover:bg-gray-100"
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}

                {/* Next */}
                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="flex items-center px-3 py-2 text-sm font-medium bg-white border rounded-full shadow-sm hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  Next
                  <FaArrowRight className="w-4 h-4 ml-1" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Equifax Modal */}
      {/* {modalOpen.equifax && selectedReport && (
        <EquifaxScoreReportModal
          isOpen={modalOpen.equifax}
          onClose={() => setModalOpen((prev) => ({ ...prev, equifax: false }))}
          Equifaxv2Report={selectedReport?.data?.credit_report}
          Equifaxv2Error={selectedReport || {}}
          submittedName={selectedReport?.name}
          submittedMobile={selectedReport?.mobile}
        />
      )} */}

      {modalOpen.equifax && selectedReport && (
        <EquifaxReport
          isOpen={modalOpen.equifax}
          onClose={() => setModalOpen((prev) => ({ ...prev, equifax: false }))}
          Equifaxv2Report={selectedReport}
          Equifaxv2Error={selectedReport || {}}
          data={selectedReport}
        />
      )}

      {/* CRIF V1 Modal */}
      {modalOpen.crif && selectedReport && (
        <CrifScoreReportModal
          isOpen={modalOpen.crif}
          onClose={() => setModalOpen((prev) => ({ ...prev, crif: false }))}
          Equifaxv2Report={selectedReport}
          Equifaxv2Error={selectedReport || {}}
          submittedName={selectedReport?.name}
          submittedMobile={selectedReport?.mobile}
        />
      )}

      {modalOpen.crifv4 && selectedReport && (
        <CrifScoreReportModal4
          isOpen={modalOpen.crifv4}
          onClose={() => setModalOpen((prev) => ({ ...prev, crifv4: false }))}
          crifV4Report={selectedReport}
          crifV4Error={selectedReport || {}}
          submittedName={selectedReport?.name}
          submittedMobile={selectedReport?.mobile}
        />
      )}

      {/* CRIF V2 Modal */}
      {modalOpen.criff && selectedReport && (
        <CrifScoreReportModal
          isOpen={modalOpen.criff}
          onClose={() => setModalOpen((prev) => ({ ...prev, criff: false }))}
          Equifaxv2Report={selectedReport?.data}
          Equifaxv2Error={selectedReport || {}}
          submittedName={selectedReport?.name}
          submittedMobile={selectedReport?.mobile}
        />
      )}

      {/* Experian V1 Modal */}
      {modalOpen.experians && selectedReport && (
        <ExperianScoreReportModals
          isOpen={modalOpen.experians}
          onClose={() =>
            setModalOpen((prev) => ({ ...prev, experians: false }))
          }
          ExperianReport={selectedReport?.data}
          Equifaxv2Error={selectedReport || {}}
        />
      )}

      {/* Experian V2 Modal */}
      {modalOpen.experian && selectedReport && (
        <ExperianScoreReportModal
          isOpen={modalOpen.experian}
          onClose={() => setModalOpen((prev) => ({ ...prev, experian: false }))}
          ExperianReport={
            selectedReport?.result?.result_json?.INProfileResponse
          }
          Equifaxv2Error={selectedReport || {}}
        />
      )}

      {/* Experian V3 Modal */}
      {modalOpen.experiann && selectedReport && (
        <ExperianScoreReportModall
          isOpen={modalOpen.experiann}
          onClose={() =>
            setModalOpen((prev) => ({ ...prev, experiann: false }))
          }
          ExperianReport={
            selectedReport?.result?.result_json?.INProfileResponse ||
            selectedReport?.data
          }
          Equifaxv2Error={selectedReport || {}}
        />
      )}

      {/* TransUnion V1 Modal */}
      {modalOpen.transunion && selectedReport && (
        <TransUnionReportModal
          isOpen={modalOpen.transunion}
          onClose={() =>
            setModalOpen((prev) => ({ ...prev, transunion: false }))
          }
          TransUnionReport={selectedReport?.data}
          Equifaxv2Error={selectedReport || {}}
        />
      )}

      {/* TransUnion V2 Modal */}
      {modalOpen.transunionn && selectedReport && (
        <TransUnionReportModal2
          isOpen={modalOpen.transunionn}
          onClose={() =>
            setModalOpen((prev) => ({ ...prev, transunionn: false }))
          }
          TransUnionReport={selectedReport?.data}
          Equifaxv2Error={selectedReport || {}}
        />
      )}

      {/* TransUnion Hybrid Modal */}
      {modalOpen.transunionHybrid &&
        selectedReport &&
        (selectedReport?.status === "success" ||
          selectedReport?.status?.code === 200) && (
          <TransunionHybridModal
            // isOpen={modalOpen.transunionHybrid}
            onClose={() =>
              setModalOpen((prev) => ({ ...prev, transunionHybrid: false }))
            }
            report={formatCreditReport(selectedReport)}
          />
        )}

      {/* TransUnion V3 Modal */}
      {modalOpen.transunionnn && selectedReport && (
        <TransUnionReportModal3
          isOpen={modalOpen.transunionnn}
          onClose={() =>
            setModalOpen((prev) => ({ ...prev, transunionnn: false }))
          }
          CreditReportData={selectedReport}
          Equifaxv2Error={selectedReport || {}}
        />
      )}

      {/* Mobile Credit Score Modal */}
      {modalOpen.mobile && selectedReport && (
        <MobileDataModal
          isOpen={modalOpen.mobile}
          mobileResponseData={selectedReport?.data || selectedReport}
          onClose={() => setModalOpen((prev) => ({ ...prev, mobile: false }))}
        />
      )}

      {/* Mobile Credit Score Modal v2 prefill */}
      {modalOpen.mobile && selectedReport && (
        <MobileDataModals
          isOpen={modalOpen.mobilee}
          mobileResponseData={selectedReport?.data || selectedReport}
          onClose={() => setModalOpen((prev) => ({ ...prev, mobilee: false }))}
        />
      )}

      {jsonModalOpen && jsonReponseData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-1 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
            <div className="flex justify-end">
              <button
                onClick={() => setJsonModalOpen(false)}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Close
              </button>
            </div>
            <h2 className="text-xl font-semibold mb-2">JSON Response</h2>
            <pre className="whitespace-pre-wrap break-all text-sm">
              {JSON.stringify(jsonReponseData, null, 2)}
            </pre>
            <div className="flex justify-end">
              <button
                onClick={() => setJsonModalOpen(false)}
                className="mt-4 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreditScoreReport;
